import { Text } from '@medly-components/core';
import { centerAligned, getFontStyle } from '@medly-components/utils';
import styled from 'styled-components';

export const DarkFlatButton = styled.button`
    outline: none;
    border: none;
    cursor: pointer;
    padding: 0;
    background-color: transparent;
    min-width: fit-content;
    max-height: 4.8rem;
    ${centerAligned('inline-flex')}
    & > svg + ${Text.Style} {
        margin-left: 0.8rem;
    }
    & > ${Text.Style} {
        ${({ theme }) => getFontStyle({ theme, fontVariant: 'button1', fontWeight: 'Medium' })}
    }
`;

export const DarkOutlinedButton = styled(DarkFlatButton)`
    padding: 1.2rem;
    border-radius: 0.8rem;
    border: 0.1rem solid ${({ theme }) => theme.colors.grey[600]};
`;
